import { render, staticRenderFns } from "./MeitavMonthlySavingInsight.vue?vue&type=template&id=4dd52e92&scoped=true"
import script from "./MeitavMonthlySavingInsight.vue?vue&type=script&lang=js"
export * from "./MeitavMonthlySavingInsight.vue?vue&type=script&lang=js"
import style0 from "./MeitavMonthlySavingInsight.vue?vue&type=style&index=0&id=4dd52e92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd52e92",
  null
  
)

export default component.exports